/**
 * Module definition houses newman application services
 *
 * @module services.newman
 */
angular.module('services.newman', [
  'services.newman.CasesService',
  'services.newman.DecisionsService',
  'services.newman.DuplicateService',
  'services.newman.ExportService',
  'services.newman.ImportService',
  'services.newman.LoginService',
  'services.newman.MagicService',
  'services.newman.PublishService',
  'services.newman.RulesService',
  'services.newman.StatesService',
  'services.newman.TemplatesService',
  'services.newman.ThemesService',
  'services.newman.UsersService',
  'services.newman.WidgetsService',
  'services.newman.PaginationService'
]);
